import React from 'react';

/**
 * CheckboxField component - handles checkbox input type
 */
function CheckboxField({ field, index, value, onChange, formId }) {
    const fieldId = `${formId}_${field.name}_${index}`;

    return (
        <div className="flex items-center">
            <input
                type="checkbox"
                id={fieldId}
                checked={value || false}
                onChange={(e) => onChange(index, e.target.checked)}
                className="mr-2"
            />
            <span className="text-sm text-content">{field.label}</span>
        </div>
    );
}

export default CheckboxField;
